/* GuideGxP funnel events. Reuses the official Google & YouTube tag; never initializes another tag. */
(function () {
  'use strict';
  const configElement = document.getElementById('gxp-funnel-config');
  if (!configElement || configElement.dataset.ready) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  if (!['index', 'page', 'article', 'blog', 'collection', 'product'].includes(config.page_type)) return;
  configElement.dataset.ready = 'true';
  const preview = !window.Shopify || !window.Shopify.theme || window.Shopify.theme.role !== 'main';
  const queue = [];
  const seen = new WeakSet();
  const viewTargets = new Map();
  const navigationKey = 'gxp_funnel_navigation_v1';
  let retryTimer;
  let checklistPending = false;
  let checklistSuccess = false;
  const safe = value => String(value || '').replace(/[^a-zA-Z0-9_\-/]/g, '').slice(0, 100);

  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function diagnostic() {
    if (preview) configElement.dataset.analytics = !window.Shopify?.customerPrivacy ? 'privacy-loading' : !allowed() ? 'consent-denied' : typeof window.gtag === 'function' ? 'ready' : 'tag-loading';
  }
  function cleanURL(value) {
    try { const url = new URL(value, window.location.href); return url.origin + url.pathname; }
    catch (_) { return ''; }
  }
  function deliver(item) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    try { window.gtag('event', item.name, item.params); return true; }
    catch (_) { return false; }
  }
  function flush() {
    clearTimeout(retryTimer);
    if (!allowed()) { queue.length = 0; return; }
    while (queue.length) {
      if (Date.now() - queue[0].time > 10000) { queue.shift(); continue; }
      if (!deliver(queue[0])) break;
      queue.shift();
    }
    if (queue.length) retryTimer = setTimeout(flush, 250);
  }
  function track(name, details, callback, stageNavigation) {
    diagnostic();
    // Activity before consent is deliberately neither stored nor replayed.
    if (!allowed()) return false;
    const params = {
      send_to: config.measurement_id,
      page_location: cleanURL(window.location.href),
      page_referrer: document.referrer ? cleanURL(document.referrer) : '',
      page_type: safe(config.page_type),
      language: safe(config.language),
      content_group: safe(config.content_group),
      gxp_environment: preview ? 'preview' : 'production'
    };
    if (callback) { params.event_callback = callback; params.event_timeout = 250; }
    if (config.article_id) params.article_id = safe(config.article_id);
    if (preview) params.debug_mode = true;
    // Whitelist parameters. Never send email, form contents, query strings or customer identifiers.
    for (const key of ['placement', 'destination', 'product_handle', 'plan_name', 'billing_period', 'popup_source']) {
      if (details && details[key]) params[key] = safe(details[key]);
    }
    const item = { name, params, time: Date.now() };
    if (stageNavigation) {
      try { window.sessionStorage.setItem(navigationKey, JSON.stringify(item)); return true; }
      catch (_) { return false; }
    }
    if (!deliver(item)) {
      if (queue.length >= 20) queue.shift();
      queue.push(item);
      flush();
    }
    return true;
  }
  function resumeNavigation() {
    if (!window.Shopify?.customerPrivacy) return;
    try {
      const raw = window.sessionStorage.getItem(navigationKey);
      window.sessionStorage.removeItem(navigationKey);
      if (!raw || !allowed()) return;
      const item = JSON.parse(raw);
      if (Date.now() - item.time > 15000 || Date.now() < item.time || !['gxp_cta_click', 'gxp_plan_select'].includes(item.name) || item.params?.send_to !== config.measurement_id) return;
      queue.push(item);
      flush();
    } catch (_) { /* Storage can be unavailable in private browsing. */ }
  }
  function placement(element) {
    const toolkit = element.closest('[data-gxp-article-cta]');
    if (toolkit) return toolkit.dataset.placement === 'end' ? 'article_toolkit_end' : 'article_toolkit_inline';
    const regions = [
      ['[data-gxp-chatgxp-article]', 'article_chatgxp'],
      ['[data-gxp-article-cta]', 'article_toolkit'],
      ['.gxh-service-panel', 'home_services'],
      ['.gxh-hero', 'home_hero'],
      ['.gxh-guides', 'home_guides'],
      ['.gxh-chatgxp', 'home_chatgxp'],
      ['.gxh-newsletter', 'home_newsletter'],
      ['.gxh-learn', 'home_learning'],
      ['#piani', 'chatgxp_plans'],
      ['.cgx-hero', 'chatgxp_hero'],
      ['.cgx-pnav', 'chatgxp_navigation'],
      ['.cgx-cta', 'chatgxp_bottom'],
      ['.shopify-section-header, header.header, header-drawer', 'header'],
      ['footer.footer, [id^="gxpf-"]', 'footer']
    ];
    for (const [selector, name] of regions) if (element.closest(selector)) return name;
    if (config.page_handle === 'about-us') return 'about_team';
    return config.page_type === 'article' ? 'article_body' : 'page_content';
  }
  function target(link) {
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return null; }
    if (url.protocol !== 'https:') return null;
    if (url.hostname === 'chat.guidegxp.com') return { destination: 'chatgxp_app' };
    if (!['www.guidegxp.com', 'guidegxp.com'].includes(url.hostname)) return null;
    if (/\/pages\/chatgxp\/?$/.test(url.pathname)) return { destination: url.hash === '#piani' ? 'chatgxp_plans' : 'chatgxp' };
    if (/\/products\//.test(url.pathname)) return { destination: 'guide', product_handle: url.pathname.split('/products/')[1].split('/')[0] };
    if (/\/collections\//.test(url.pathname)) return { destination: 'catalog' };
    if (/\/pages\/the-pragmatic-gmp\/?$/.test(url.pathname)) return { destination: 'newsletter' };
    if (/\/pages\/(pharma-engineering|pharma-lab|gxp-academy)\/?$/.test(url.pathname)) return { destination: 'learning' };
    if (url.hash === '#gxh-resources' || /\/blogs\//.test(url.pathname)) return { destination: 'learning' };
    if (/\/pages\/contact/.test(url.pathname)) return { destination: 'contact' };
    return null;
  }
  function clickEvent(name, details, control, event) {
    const url = new URL(control.href, window.location.href);
    const current = new URL(window.location.href);
    const leavingPage = url.origin !== current.origin || url.pathname !== current.pathname || url.search !== current.search;
    const normalNavigation = leavingPage && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !control.hasAttribute('download') && (!control.target || control.target === '_self');
    // A same-origin navigation can unload before Google's batch is sent. Carry this one
    // consented event into the next storefront page, preserving the source page and CTA.
    // It is removed on read, expires after 15 seconds and is discarded if consent is revoked.
    if (normalNavigation && url.origin === current.origin && allowed() && track(name, details, null, true)) return;
    if (!normalNavigation || !allowed() || typeof window.gtag !== 'function') { track(name, details); return; }
    // Flush before navigation; never hold a visitor for more than 250 ms if the tag is blocked.
    event.preventDefault();
    let navigated = false;
    const go = () => { if (!navigated) { navigated = true; window.location.assign(url.href); } };
    const fallback = setTimeout(go, 250);
    track(name, details, () => { clearTimeout(fallback); go(); });
  }
  document.addEventListener('click', function (event) {
    if (event.button !== undefined && event.button !== 0) return;
    const control = event.target.closest('a[href], [data-gxp-checklist-open]');
    if (!control) return;
    if (control.matches('[data-gxp-checklist-open]')) {
      track('gxp_cta_click', { destination: 'checklist', placement: placement(control) });
      return;
    }
    if (control.closest('#piani .cgx-pc-foot')) {
      const url = new URL(control.href, window.location.href);
      const plan = url.searchParams.get('plan');
      const period = url.searchParams.get('period');
      if (url.hostname === 'chat.guidegxp.com' && ['pro', 'max'].includes(plan) && ['month', 'year'].includes(period)) {
        clickEvent('gxp_plan_select', { plan_name: plan, billing_period: period, placement: 'chatgxp_plans', destination: 'chatgxp_app' }, control, event);
        return;
      }
      if (control.closest('.cgx-pc--team')) {
        clickEvent('gxp_plan_select', { plan_name: 'team', placement: 'chatgxp_plans', destination: 'contact' }, control, event);
        return;
      }
    }
    const details = target(control);
    if (details) clickEvent('gxp_cta_click', { ...details, placement: placement(control) }, control, event);
  }, true);
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cgx-period]') || !event.target.checked) return;
    const period = event.target.getAttribute('data-cgx-period');
    if (['month', 'year'].includes(period)) track('gxp_billing_change', { billing_period: period, placement: 'chatgxp_plans' });
  });

  const dialog = document.getElementById('guidegxp-checklist');
  if (dialog) {
    const source = () => dialog.dataset.openedBy === 'automatic' ? 'automatic' : 'manual';
    document.addEventListener('gxp:checklist:open', function () {
      checklistPending = false;
      track('gxp_checklist_open', { popup_source: source(), placement: 'checklist_popup' });
    });
    dialog.querySelector('form').addEventListener('submit', function () {
      checklistPending = true;
      track('gxp_checklist_submit', { popup_source: source(), placement: 'checklist_popup' });
    });
    document.addEventListener('gxp:checklist:success', function () {
      // This means MailerLite accepted the request, not email confirmation or file delivery.
      if (!checklistPending || checklistSuccess) return;
      checklistSuccess = true;
      track('gxp_checklist_success', { popup_source: source(), placement: 'checklist_popup' });
    });
  }

  function visible(element) {
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height || element.closest('[hidden]')) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    const visibleWidth = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
    return visibleHeight >= Math.min(rect.height, window.innerHeight) * 0.5 && visibleWidth > 0;
  }
  function checkView(element) {
    if (seen.has(element) || !visible(element) || document.visibilityState === 'hidden') return;
    const info = viewTargets.get(element);
    if (info && track(info.name, info.details)) seen.add(element);
  }
  function checkViews() { viewTargets.forEach((_, element) => checkView(element)); }
  document.querySelectorAll('[data-gxp-chatgxp-article-link], [data-gxp-article-cta-link]').forEach(element => {
    const details = target(element);
    if (details) viewTargets.set(element, { name: 'gxp_cta_view', details: { ...details, placement: placement(element) } });
  });
  const plans = document.querySelector('#cgx-plans-h');
  if (plans) viewTargets.set(plans, { name: 'gxp_plans_view', details: { placement: 'chatgxp_plans' } });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) checkView(entry.target); }), { threshold: [0, 0.5] });
    viewTargets.forEach((_, element) => observer.observe(element));
  }
  document.addEventListener('visibilitychange', checkViews);
  document.addEventListener('visitorConsentCollected', function () { diagnostic(); resumeNavigation(); flush(); checkViews(); });
  window.addEventListener('pageshow', resumeNavigation);
  // Let the Shopify privacy API finish loading; only current visible impressions are eligible.
  let privacyChecks = 0;
  function ready() {
    diagnostic();
    resumeNavigation();
    checkViews();
    if (++privacyChecks < 40 && !(window.Shopify && window.Shopify.customerPrivacy)) setTimeout(ready, 250);
  }
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      if (!error) { diagnostic(); resumeNavigation(); checkViews(); }
    });
  }
  ready();
})();
